/*
  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign
  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner
*/
(function () {
  "use strict";

  /* In case you want to output a bunch of things to the debug console */
  var debug = false;
  var cartCookie;

  function log(text) {
    console.log(text);
  }

  /* The ID of the element that you want to add the shipping fields into */
  var productSection = document.getElementsByClassName("frete-produto");
  if (!productSection.length) {
    log("Could not find the element");
    return;
  }

  /* Read the purchase controls from this PDP, excluding sticky/installment forms. */
  var productRoot = productSection[0].closest(".dm-product-bold-inspired") ||
    productSection[0].closest(".productView") ||
    productSection[0].closest("section");
  var getProductForm = function () {
    return productRoot?.querySelector(
      'form[id^="product-form-"]:not([id^="product-form-installment-"]):not([id^="product-form-sticky-"])'
    );
  };
  var getProductSelect = function () {
    return getProductForm()?.querySelector('[name="id"]') ||
      productRoot?.querySelector("#ProductSelect-product-template");
  };
  var getProductQuantity = function () {
    var input = productRoot?.querySelector('.dm-product-quantity input[name="quantity"]') ||
      getProductForm()?.querySelector('[name="quantity"]') ||
      productRoot?.querySelector('.quantity__group--1 input[name="quantity"]') ||
      productRoot?.querySelector("#Quantity");
    var quantity = Number.parseInt(input?.value || "1", 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };
  var getPurchaseSignature = function () {
    return (getProductSelect()?.value || "") + "|" + getProductQuantity();
  };
  var productSelect = getProductSelect();
  if (!productSelect) {
    log("Could not find the main select element");
    return;
  }

  /* create a message box */
  var shippingMessage = document.createElement("p");
  var shippingCountry = document.createElement("select");
  var shippingProvince = document.createElement("select");
  var shippingZip = document.createElement("input");
  var freteLista = document.createElement("div");
  var shippingModule = productSection[0].closest(".frete-calculo");
  var isBoldProduct = Boolean(productSection[0].closest(".dm-product-bold-inspired"));
  var shippingCalcButton;
  var shippingButtonText = "OK";
  var shippingRequest = 0;
  var purchaseSignature = getPurchaseSignature();
  var shippingQuoteStarted = false;
  var shippingRequotePending = false;
  var shippingRequoteTimer;

  var scheduleShippingRequote = function () {
    clearTimeout(shippingRequoteTimer);
    shippingRequoteTimer = setTimeout(function () {
      if (!shippingRequotePending || shippingCalcButton.disabled) return;
      shippingRequotePending = false;
      if (shippingZip.value.replace(/\D/g, "").length === 8) shippingCalcButton.onclick();
    }, 150);
  };

  var setShippingLoading = function (isLoading) {
    if (!shippingCalcButton) return;
    shippingCalcButton.disabled = isLoading;
    shippingCalcButton.setAttribute("aria-busy", String(isLoading));
    shippingCalcButton.innerText = isLoading ? "Calculando…" : shippingButtonText;
    if (!isLoading && shippingRequotePending) scheduleShippingRequote();
  };

  /* Erro Frete */
  shippingMessage.classList.add("erros-fretes");
  shippingMessage.setAttribute("style", "display:none");
  shippingMessage.setAttribute("role", "status");
  shippingMessage.setAttribute("aria-live", "polite");

  /* Ajustes da lista de fretes */
  freteLista.classList.add("listas-de-fretes");
  freteLista.setAttribute("style", "display:none");
  freteLista.setAttribute("role", "status");
  freteLista.setAttribute("aria-live", "polite");

  /* We are just adding some dummy fields for example only. There's better ways to handle this */
  var initFields = function () {
    /* create the country picker */
    shippingCountry.id = "pais-simulator";

    var countries = ["Brazil"];
    for (var i = 0; i < countries.length; i++) {
      shippingCountry.add(new Option(countries[i], countries[i], i === 0));
    }
    shippingCountry.name = "shipping_address[country]";

    /* create the province state picker */
    shippingProvince.id = "estados-simulator";

    var provinces = [
      "Acre",
      "Alagoas",
      "Amapa",
      "Amazonas",
      "Bahia",
      "Ceara",
      "Distrito Federal",
      "Espirito Santo",
      "Goias",
      "Maranhao",
      "Mato Grosso",
      "Mato Grosso do Sul",
      "Minas Gerais",
      "Para",
      "Paraiba",
      "Parana",
      "Pernambuco",
      "Piaui",
      "Rio de Janeiro",
      "Rio Grande do Norte",
      "Rio Grande do Sul",
      "Rondonia",
      "Roraima",
      "Santa Catarina",
      "Sao Paulo",
      "Sergipe",
      "Tocantins",
    ];
    for (var i = 0; i < provinces.length; i++) {
      shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
    }
    shippingProvince.name = "shipping_address[province]";

    /* create the zip / postcode field */
    shippingZip.type = "tel";
    shippingZip.inputMode = "numeric";
    shippingZip.autocomplete = "postal-code";
    shippingZip.name = "shipping_address[zip]";
    shippingZip.className = "Form__Input cep-calculo-frete form-control";
    shippingZip.placeholder = shippingModule?.dataset.placeholder || "Digite seu CEP";
    shippingZip.setAttribute("aria-label", shippingZip.placeholder);
    shippingZip.addEventListener("input", function (e) {
      const input = shippingZip;
      const previousDigits = input.dataset.cepDigits || "";
      const raw = input.value;
      let digits = raw.replace(/\D/g, "");
      let before = raw.slice(0, input.selectionStart ?? raw.length).replace(/\D/g, "").length;
      // Apagar o separador deve apagar o dígito vizinho, sem prender o cursor.
      if (digits === input.dataset.cepDigits && raw !== input.dataset.cepMask &&
          /^deleteContent(Backward|Forward)$/.test(e.inputType || "")) {
        const index = e.inputType === "deleteContentBackward" ? before - 1 : before;
        if (index >= 0 && index < digits.length) {
          digits = digits.slice(0, index) + digits.slice(index + 1);
          if (e.inputType === "deleteContentBackward") before -= 1;
        }
      }
      const masked = digits.length > 5 ? digits.slice(0, 5) + "-" + digits.slice(5) : digits;
      input.value = masked;
      input.dataset.cepDigits = digits;
      input.dataset.cepMask = masked;
      const caret = Math.min(masked.length, before + (before > 5 ? 1 : 0));
      input.setSelectionRange(caret, caret);
      if (digits !== previousDigits) {
        shippingRequest += 1;
        freteLista.innerHTML = "";
        freteLista.setAttribute("style", "display:none");
      }
      shippingMessage.textContent = "";
      shippingMessage.setAttribute("style", "display:none");
    });

    /* create a wrapper for the fields */
    var shippingCalcWrapper = document.createElement("div");
    shippingCalcWrapper.className = "shipping-calc-wrapper";

    /* create a wrapper for the fields */
    var formularioFrete = document.createElement("div");
    formularioFrete.className = "formulario-frete";

    /* create a title */
    var shippingCalcTitle = document.createElement("p");
    shippingCalcTitle.innerText = "Simule seu frete";

    /* create a get rates button */
    shippingCalcButton = document.createElement("button");
    shippingCalcButton.type = "button";
    shippingButtonText = shippingModule?.dataset.buttonText || "OK";
    if (isBoldProduct && shippingButtonText.trim().toUpperCase() === "OK") {
      shippingButtonText = "Calcular";
    }
    shippingCalcButton.innerText = shippingButtonText;
    shippingCalcButton.className = "btn btn-underline button";
    shippingCalcButton.onclick = function () {
      if (shippingCalcButton.disabled) return;
      productSelect = getProductSelect();
      if (!productSelect) return;
      var quantity = getProductQuantity();
      purchaseSignature = getPurchaseSignature();
      var cepLimpo = shippingZip.value.replace(/\D/g, "");
      var request = ++shippingRequest;
      freteLista.innerHTML = "";
      freteLista.setAttribute("style", "display:none");

      shippingMessage.textContent = "";
      shippingMessage.setAttribute("style", "display:none");
      if (cepLimpo.length !== 8) {
        shippingMessage.textContent = "Digite um CEP válido com 8 números.";
        shippingMessage.setAttribute("style", "display:flex");
        shippingZip.focus();
        return;
      }

      shippingQuoteStarted = true;
      shippingRequotePending = false;
      clearTimeout(shippingRequoteTimer);
      setShippingLoading(true);
      $.ajax({
        url: "https://viacep.com.br/ws/" + cepLimpo + "/json/",
        dataType: "jsonp",
        timeout: 10000,
        success: function (dados) {
          if (request !== shippingRequest) {
            setShippingLoading(false);
            return;
          }
          if (dados && !dados.erro && dados.uf && String(dados.cep || "").replace(/\D/g, "") === cepLimpo) {
            switch (dados.uf) {
              case "AC":
                dados.uf = "Acre";
                break;
              case "AL":
                dados.uf = "Alagoas";
                break;
              case "AP":
                dados.uf = "Amapa";
                break;
              case "AM":
                dados.uf = "Amazonas";
                break;
              case "BA":
                dados.uf = "Bahia";
                break;
              case "CE":
                dados.uf = "Ceara";
                break;
              case "DF":
                dados.uf = "Distrito Federal";
                break;
              case "ES":
                dados.uf = "Espirito Santo";
                break;
              case "GO":
                dados.uf = "Goias";
                break;
              case "MA":
                dados.uf = "Maranhao";
                break;
              case "MT":
                dados.uf = "Mato Grosso";
                break;
              case "MS":
                dados.uf = "Mato Grosso do Sul";
                break;
              case "MG":
                dados.uf = "Minas Gerais";
                break;
              case "PA":
                dados.uf = "Para";
                break;
              case "PB":
                dados.uf = "Paraiba";
                break;
              case "PR":
                dados.uf = "Parana";
                break;
              case "PE":
                dados.uf = "Pernambuco";
                break;
              case "PI":
                dados.uf = "Piaui";
                break;
              case "RJ":
                dados.uf = "Rio de Janeiro";
                break;
              case "RN":
                dados.uf = "Rio Grande do Norte";
                break;
              case "RS":
                dados.uf = "Rio Grande do Sul";
                break;
              case "RO":
                dados.uf = "Rondonia";
                break;
              case "RR":
                dados.uf = "Roraima";
                break;
              case "SC":
                dados.uf = "Santa Catarina";
                break;
              case "SP":
                dados.uf = "Sao Paulo";
                break;
              case "SE":
                dados.uf = "Sergipe";
                break;
              case "TO":
                dados.uf = "Tocantins";
                break;
            }

            shippingProvince.value = dados.uf;

            if (!productSelect.value.length) {
              console.log("Nenhuma variação selecionada"); /* return false*/
            }
            cartCookie = getCookie("cart");
            var tempCookieValue =
              tempCookieValue || "temp-cart-cookie___" + Date.now();
            var fakeCookieValue =
              fakeCookieValue || "fake-cart-cookie___" + Date.now();

            /* if not found, make a new temp cookie */
            if (!cartCookie) {
              log("no cookie found");
              updateCartCookie(tempCookieValue);
              cartCookie = getCookie("cart");
            } else {
              log("cookie found");
            }

            /* if found but has a weird length, bail */
            if (cartCookie.length < 32) {
              log("cart ID not valid");
              setShippingLoading(false);
              return;
            }

            /* Change the cookie value to a new 32 character value */
            updateCartCookie(fakeCookieValue);
            log(getCookie("cart"));

            if (!productSelect.value.length) {
              getRates(parseInt($(productSelect).find("option").get(1).value), cepLimpo, request, quantity);
            } else {
              getRates(parseInt(productSelect.value), cepLimpo, request, quantity);
            }
            return false;
          } else {
            shippingMessage.textContent = dados && dados.erro
              ? "CEP não encontrado. Confira os números e tente novamente."
              : "Não foi possível consultar o CEP. Tente novamente.";
            shippingMessage.setAttribute("style", "display:flex");
            setShippingLoading(false);
          }
        }
      }).fail(function () {
        if (request !== shippingRequest) {
          setShippingLoading(false);
          return;
        }
        freteLista.innerHTML = "";
        shippingMessage.textContent = "Não foi possível consultar o CEP. Tente novamente.";
        shippingMessage.setAttribute("style", "display:flex");
        setShippingLoading(false);
      });
    };

    shippingZip.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") return;
      event.preventDefault();
      shippingCalcButton.click();
    });

    /* create some labels for the fields */
    var labelNames = ["País", "Estado", "CEP"];
    var labels = [];
    for (var i = 0; i < labelNames.length; i++) {
      var label = document.createElement("label");
      label.innerText = labelNames[i];
      labels.push(label);
    }

    shippingCalcWrapper.appendChild(formularioFrete);

    /*shippingCalcWrapper.appendChild(shippingCalcTitle);
            shippingCalcWrapper.appendChild(labels[0]);*/
    formularioFrete.appendChild(shippingCountry);
    /*shippingCalcWrapper.appendChild(labels[1]);*/
    formularioFrete.appendChild(shippingProvince);
    /*shippingCalcWrapper.appendChild(labels[2]);*/
    formularioFrete.appendChild(shippingZip);
    formularioFrete.appendChild(shippingCalcButton);
    shippingCalcWrapper.appendChild(shippingMessage);
    shippingCalcWrapper.appendChild(freteLista);

    /* add to the page */
    productSection[0].appendChild(shippingCalcWrapper);
  };

  /* A console logging function */
  var log = function (a) {
    if (!debug) {
      return;
    }
    console.log(a);
  };

  /* get cookie by name */
  var getCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  };

  /* update the cart cookie value */
  var updateCartCookie = function (a) {
    log("changing cart cookie value to: " + a);
    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "cart=" + a + expires + "; path=/";
  };

  /* reset the cart cookie value */
  var resetCartCookie = function () {
    updateCartCookie(cartCookie);
    log(getCookie("cart"));
  };

  /* get the rates */
  var getRates = function (variantId, zip, request, quantity) {
    var province = shippingProvince.value;
    $(".listas-de-fretes").html("");
    $(".listas-de-fretes").show();

    /* add whatever sanity checks you need in addition to the one below */
    if (typeof variantId === "undefined") {
      setShippingLoading(false);
      return;
    }

    var addData = {
      id: variantId,
      quantity: quantity,
    };

    function isDateBeforeToday(date) {
      return (
        new Date(date.toDateString()) < new Date(new Date().toDateString())
      );
    }

    function excludeDate(name) {
      var response =
        name !=
          "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis" &&
        name != "Entrega Rápida - pedidos chegam em até 48hrs úteis";
      return response;
    }

    fetch("/cart/add.js?_easygift_internal=true", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With":
          "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
      },
      method: "POST",
    })
      .then(function (response) {
        /* /cart/add.js responde 422 quando a variante nao pode entrar no carrinho
           — produto esgotado, por exemplo. fetch nao rejeita em 4xx, entao o
           status precisa ser checado aqui; sem isso o fluxo seguia pedindo frete
           para um item que nunca entrou no carrinho. */
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (request !== shippingRequest) {
          resetCartCookie();
          setShippingLoading(false);
          return;
        }
        if (!result.ok) {
          resetCartCookie();
          $(".listas-de-fretes").html("");
          shippingMessage.textContent =
            "Produto indisponivel no momento — nao e possivel calcular o frete.";
          shippingMessage.setAttribute("style", "display:flex");
          setShippingLoading(false);
          return;
        }

        $.ajax({
          type: "GET",
          url: "/cart/shipping_rates.json?_easygift_internal=true",
          data: {
            "shipping_address[country]": shippingCountry.value,
            "shipping_address[province]": province,
            "shipping_address[zip]": zip,
          },
          beforeSend: function () {
            //Aqui adicionas o loader
            $(".listas-de-fretes").html(
              "<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543' width='30px' style='width:30px; height: 30px; margin:0 auto'>"
            );
          },
          success: function (d) {
            if (request !== shippingRequest) {
              resetCartCookie();
              setShippingLoading(false);
              return;
            }
            /* Fora do if: com zero cotacoes o bloco abaixo nao roda, e o GIF
               ficava girando indefinidamente. */
            $("#loading-icon-frete").remove();

            if (d.shipping_rates && d.shipping_rates.length) {
              for (var i = 0; i < d.shipping_rates.length; i++) {
                var deliveryDate = d.shipping_rates[i].delivery_date;

                var entrega = new Date(d.shipping_rates[i].delivery_date);
                var checkBeforeday = isDateBeforeToday(entrega);
                var excludeDateCheck = excludeDate(d.shipping_rates[i].name);
                let dataFormatada =
                  entrega.getDate() +
                  "/" +
                  (entrega.getMonth() + 1) +
                  "/" +
                  entrega.getFullYear();

                var valorFrete = d.shipping_rates[i].price;

                if (valorFrete == "0.00" || valorFrete == null) {
                  valorFrete = "Grátis";
                } else {
                  valorFrete = Shopify.formatMoney(
                    Math.round(Number(valorFrete) * 100),
                    "R$ {{amount_with_comma_separator}}"
                  );
                }

                if (
                  (deliveryDate == null && excludeDateCheck) ||
                  (checkBeforeday && excludeDateCheck)
                ) {
                  entrega = "Estimativa de entrega indisponível";
                } else if (!excludeDateCheck) {
                  if (
                    d.shipping_rates[i].name ==
                    "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis"
                  ) {
                    entrega = "";
                  } else {
                    entrega = "";
                  }
                } else {
                  entrega = "(Estimativa de entrega: " + dataFormatada + ")";
                }

                $(
                  '<div class="frete-item"> <div> <p class="m-0 nome-frete"><b>' +
                    d.shipping_rates[i].name +
                    '</b> <span class="estimativa-de-entrega">' +
                    entrega +
                    '</span></p> </div><div class="frete-valor">Valor: <b> ' +
                    valorFrete +
                    "</b></div> </div>"
                ).appendTo(".listas-de-fretes");
              }

            } else {
              shippingMessage.textContent =
                "Nenhuma opcao de frete encontrada para este CEP.";
              shippingMessage.setAttribute("style", "display:flex");
            }
            resetCartCookie();
            setShippingLoading(false);
          },
          error: function () {
            resetCartCookie();
            if (request !== shippingRequest) {
              setShippingLoading(false);
              return;
            }
            $(".listas-de-fretes").html("");
            shippingMessage.textContent = "Não foi possível calcular o frete para este CEP.";
            shippingMessage.setAttribute("style", "display:flex");
            setShippingLoading(false);
          },
          dataType: "json",
        }).fail(function () {
          setShippingLoading(false);
        });
      })
      .catch(function (err) {
        /* uh oh, we have error. */
        console.error(err);
        resetCartCookie();
        freteLista.innerHTML = "";
        if (request !== shippingRequest) {
          setShippingLoading(false);
          return;
        }
        shippingMessage.textContent = "Não foi possível calcular o frete agora. Tente novamente.";
        shippingMessage.setAttribute("style", "display:flex");
        setShippingLoading(false);
      });
  };

  /* Requote the latest selection after any pending request restores the cart cookie. */
  var invalidatePurchaseQuote = function () {
    var signature = getPurchaseSignature();
    if (signature === purchaseSignature) return;
    purchaseSignature = signature;
    shippingRequest += 1;
    freteLista.innerHTML = "";
    freteLista.setAttribute("style", "display:none");
    shippingMessage.textContent = "";
    shippingMessage.setAttribute("style", "display:none");
    if (shippingQuoteStarted && shippingZip.value.replace(/\D/g, "").length === 8) {
      shippingRequotePending = true;
      scheduleShippingRequote();
    }
  };
  productRoot?.addEventListener("input", function (event) {
    if (event.target.matches('[name="quantity"]')) invalidatePurchaseQuote();
  });
  productRoot?.addEventListener("change", function (event) {
    if (event.target.matches('[name="id"], [name="quantity"], variant-radios input, variant-selects select')) {
      invalidatePurchaseQuote();
    }
  });
  productRoot?.addEventListener("variant:change", invalidatePurchaseQuote);

  initFields();
})();
